import axios from 'lib/axios'

function check(callback) {
  return new Promise((resolve, reject) => {
    const success = (response) => {
      resolve(response)
    }

    const error = (xhr) => {
      console.log("Error", xhr)
      reject(xhr)
    }

    callback(success, error)
  })
}

export function callGet(url) {
  return check((res, rej) => axios.get(url).then(res).catch(rej))
}

export function callPost(url, params) {
  return check((res, rej) => axios.post(url, params).then(res).catch(rej))
}

export function callDelete(url, params = {}) {
  return check((res, rej) => axios.delete(url, params).then(res).catch(rej))
}